import React from 'react';

function ContactSection() {

    return (
        <section id="contact" className="contact-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title">Свяжитесь с нами</h2>
                </div>
                <div className="row">
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                        <div className="contact-info-item">
                            <div className="contact-info-icon">📞</div>
                            <div className="contact-info-text">
                                <h5>Телефон</h5>
                                <a href="tel:+79068500007" className="text-light text-decoration-none mb-2">
                                    +7 (906) 850-00-07
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                        <div className="contact-info-item">
                            <div className="contact-info-icon">📞</div>
                            <div className="contact-info-text">
                                <h5>Телефон</h5>
                                <a href="tel:+79090948654" className="text-light text-decoration-none">
                                    +7 (909) 094-86-54
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                        <div className="contact-info-item">
                            <div className="contact-info-icon">📍</div>
                            <div className="contact-info-text">
                                <h5>Адрес</h5>
                                <p>г. Магнитогорск</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                        <div className="contact-info-item">
                            <div className="contact-info-icon">🕐</div>
                            <div className="contact-info-text">
                                <h5>Режим работы</h5>
                                <p>Пн-Сб: 9:00 - 20:00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactSection;